module.exports = {
	title:'首页',
	dayprice:'今日销售额',
	daysale:'今日销量',
	online:'在线数',
	offline:'离线数',
	goodtotal:'商品总销量排行',
	vmtotal:'设备总销量排行',
	goodday:'商品今日销量排行',
	vmday:'设备今日销量排行',
	daysummary:'日销售汇总',
	monthsummary:'月销售汇总',
	yearsummary:'年销售汇总'
}


// WEBPACK FOOTER //
// ./src/i18n/locales/zh-cn/modules/home.js